import ErrorState from '@pinecast/common/ErrorState';
import LoadingState from '@pinecast/common/LoadingState';
import type {QueryResult} from '@pinecast/gql';
import type {RecurringDonationSupplemental} from '@pinecast/gql/__generated_tj__/RecurringDonationSupplemental';
import {defineMessages, FormattedMessage} from '@pinecast/i18n';

import ReceiptList from './ReceiptList';

const messages = defineMessages({
  loading: {
    id: 'tj-spa.RecurringDonationReceipts.loading',
    description: 'Loading message for receipts for a podcast subscription',
    defaultMessage: 'Loading receipt info…',
  },
  error: {
    id: 'tj-spa.RecurringDonationReceipts.error',
    description: 'Error message for receipts for a podcast subscription',
    defaultMessage: 'Could not load receipt information',
  },
});

type Props = {
  supplemental: QueryResult<RecurringDonationSupplemental>;
};

const RecurringDonationReceipts = ({supplemental}: Props) => {
  if (supplemental.loading) {
    return <LoadingState title={<FormattedMessage {...messages.loading} />} />;
  }
  if (supplemental.error) {
    return <ErrorState title={<FormattedMessage {...messages.error} />} />;
  }
  return <ReceiptList events={supplemental.data.tipJarSubscription!.events} />;
};

export default RecurringDonationReceipts;
